var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center px-8 h-28 w-full bg-surface-hover text-muted"},[_c('fluent-icon',{attrs:{"icon":"document-error","size":"32"}}),_vm._v(" "),_c('p',{staticClass:"mb-0 text-muted"},[_vm._v("\n    "+_vm._s(_vm.$t('COMPONENTS.FILE_BUBBLE.INSTAGRAM_STORY_UNAVAILABLE'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }